<template>
  <div class="wrap">
    <img src="@/assets/images/my-wallet/ic_left_black.png" class="left-arrow" @click="goback">
    <h3>{{title}}</h3>
  </div>
</template>

<script>

export default {
	name: 'common-header',
	props: {
		title: {
			type: String,
			required: true
		},
		
		stamp: {
			type: String,
		},
		
		peg: {
			type: String,
		},
		
		mark: {
			type: String,
		},
		
		sign: {
			type: String,
		}
	},
	
	methods: {
		goback() {
			if(this.stamp && this.peg){
				this.$router.push({path:"./index",query:{stamp:this.stamp,peg:this.peg}})
			}else if(this.mark && this.sign){
				this.$router.push({path:"./index-sale",query:{sign:this.sign,mark:this.mark}})
			}
			else{
				this.$router.go(-1)
			}
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';

.wrap {
	display: flex;
	.f-s(18);
	.p-t(10);
	.p-b(10);
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(0,0,0,1);
	background: #fff !important;
	border-bottom: 1px solid #eee;
	align-items: center;
  .left-arrow {
    .m-l(11);
    .m-r(131.5);
    .w(10);
    .h(17.5);
  }
} 
</style>